module.exports = __webpack_public_path__ + "0399c6612ff700e43d750ed790e242e8.png";